module.exports = __webpack_public_path__ + "media/project/feature_update-8104754d.svg";